
export function tuple<T extends any[]>(...elements: T) {
    return elements;
}


export type ArrayElement<ArrayType extends readonly unknown[]> = ArrayType[number];
